// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleContactMethods_wrapper__Yhh37"};